import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";

const TITLES = {
  privacy: "Polityka Prywatności",
  terms: "Regulamin",
  cookies: "Polityka Cookies",
  dpa: "Umowa Powierzenia Przetwarzania (DPA)",
  subprocessors: "Lista Subprocessors",
  "ai-note": "Informacja o AI",
};

export default function LegalPage() {
  const { slug } = useParams();
  const [html, setHtml] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!TITLES[slug]) {
      setError("not-found");
      return;
    }
    fetch(`/legal/${slug}.html`)
      .then((r) => {
        if (!r.ok) throw new Error("not-found");
        return r.text();
      })
      .then(setHtml)
      .catch(() => setError("not-found"));
  }, [slug]);

  if (error === "not-found") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-2">Dokument nie został znaleziony</h1>
          <Link to="/" className="text-blue-600 hover:underline">← Powrót</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="text-xl font-bold text-blue-600">DuoFit</Link>
          <Link to="/" className="text-sm text-gray-600 hover:text-gray-900">← Powrót</Link>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-6 py-10">
        <style>{`
          .legal-content { color: #1f2937; line-height: 1.7; }
          .legal-content h1 { font-size: 1.875rem; font-weight: 700; margin: 0 0 1rem 0; color: #0f172a; }
          .legal-content h2 { font-size: 1.5rem; font-weight: 700; margin: 2rem 0 1rem 0; color: #0f172a; padding-top: 1rem; border-top: 1px solid #e5e7eb; }
          .legal-content h3 { font-size: 1.25rem; font-weight: 600; margin: 1.5rem 0 0.75rem 0; color: #0f172a; }
          .legal-content h2:first-child { padding-top: 0; border-top: none; }
          .legal-content p { margin: 0.75rem 0; }
          .legal-content ul, .legal-content ol { margin: 0.75rem 0; padding-left: 1.5rem; }
          .legal-content li { margin: 0.25rem 0; }
          .legal-content a { color: #2563eb; text-decoration: underline; }
          .legal-content strong { font-weight: 600; color: #0f172a; }
          .legal-content code { background: #f3f4f6; padding: 0.125rem 0.375rem; border-radius: 0.25rem; font-size: 0.875em; color: #be185d; }
          .legal-content pre { background: #f3f4f6; padding: 1rem; border-radius: 0.375rem; overflow-x: auto; margin: 1rem 0; }
          .legal-content pre code { background: transparent; padding: 0; color: inherit; }
          .legal-content table { width: 100%; border-collapse: collapse; margin: 1rem 0; font-size: 0.875rem; }
          .legal-content th { background: #f3f4f6; font-weight: 600; padding: 0.5rem 0.75rem; border: 1px solid #d1d5db; text-align: left; }
          .legal-content td { padding: 0.5rem 0.75rem; border: 1px solid #d1d5db; vertical-align: top; }
          .legal-content hr { margin: 2rem 0; border: 0; border-top: 1px solid #e5e7eb; }
          .legal-content blockquote { margin: 1rem 0; padding-left: 1rem; border-left: 4px solid #e5e7eb; color: #4b5563; }
        `}</style>
        <article
          className="legal-content"
          dangerouslySetInnerHTML={{ __html: html }}
        />
        <footer className="mt-12 pt-6 border-t border-gray-200 text-sm text-gray-500">
          <p>
            Pozostałe dokumenty:{" "}
            {Object.entries(TITLES)
              .filter(([s]) => s !== slug)
              .map(([s, label], i, arr) => (
                <span key={s}>
                  <Link to={`/legal/${s}`} className="text-blue-600 hover:underline">{label}</Link>
                  {i < arr.length - 1 ? " · " : ""}
                </span>
              ))}
          </p>
        </footer>
      </main>
    </div>
  );
}
